import React from 'react';
import Row from 'olive-react-myoneui/lib/Row';
import Col from 'olive-react-myoneui/lib/Col';
import ListGroup from 'olive-react-myoneui/lib/ListGroup';
import CourseProgressBar from './ArchiveProgressBar';
import NoItems from './NoItems';
import { noReportBadgeInner } from "../../../constants/icons";

const ArchiveReport = ({ className, courses }) => {
  return (
    <div className={`${className || ''} myk__stu-courses-report-wrapper w-100`}>
      <Row>
        <Col lg={6}>
          <div className="myk__stu-report-wrapper">
            <h2>Report</h2>
            {courses?.length > 0 && (
            <div className="myk__stu-courses-report_progress">
              <ListGroup variant="flush">
                {courses.map((course, index) => (
                  <ListGroup.Item
                    key={index}
                    className="d-flex align-items-center px-0 border-0"
                  >
                    <div className="myk__stu-subject">{course.name}</div>
                    <div className="myk__stu-subject_progress">
                      <CourseProgressBar now={course.progress} />
                    </div>
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </div>
            )}
          </div>
        </Col>

        {courses?.length > 0 ? (
        <Col lg={{ span: 4, offset: 2 }}>
          <div className="myk__stu-progress_indexes ms-0 ms-lg-4">
            <h3>Grade &amp; Glossary</h3>
            <ListGroup variant="flush">
              <ListGroup.Item className="d-flex align-items-center px-0 border-0">
                <span className="myk__stu-color green"></span>
                <div className="mky__stu-subject">Excellent <span>( &lt; 90%)</span></div>
              </ListGroup.Item>
              <ListGroup.Item className="d-flex align-items-center px-0 border-0">
                <span className="myk__stu-color dark-blue"></span>
                <div className="mky__stu-subject">Good <span>(80% - 90%)</span></div>
              </ListGroup.Item>
              <ListGroup.Item className="d-flex align-items-center px-0 border-0">
                <span className="myk__stu-color maroon"></span>
                <div className="mky__stu-subject">Average <span>(60% - 70%)</span></div>
              </ListGroup.Item>
              <ListGroup.Item className="d-flex align-items-center px-0 border-0">
                <span className="myk__stu-color red"></span>
                <div className="mky__stu-subject">Needs improvement <span>( &gt; 60%)</span></div>
              </ListGroup.Item>
            </ListGroup>
          </div>
        </Col>) : (
        <Col lg={12}>
          <NoItems
            icon={noReportBadgeInner}
            title="No Reports to show!"
            description="You haven't taken any tests yet, so there are no reports available."
          />
        </Col>
        )}
      </Row>
    </div>
  );
};

export default ArchiveReport;
